import React, { ReactNode, useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { Sidebar } from "@/components/Sidebar";
import { MobileNavigation } from "@/components/MobileNavigation";
import { useIsMobile } from "@/hooks/use-mobile";
import { useUser } from "@/hooks/use-user";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

interface DashboardLayoutProps {
  children: ReactNode;
  title: string;
}

export const DashboardLayout = ({ children, title }: DashboardLayoutProps) => {
  const isMobile = useIsMobile();
  const { user, isLoading } = useUser();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!isLoading && !user) {
      toast.error("Você precisa estar logado para acessar esta página");
      navigate('/auth');
    }
  }, [user, isLoading, navigate]);

  // If still loading or user is authenticated, render the layout
  // Otherwise, navigation will redirect to auth page
  if (isLoading || user) {
    return (
      <div className="min-h-screen bg-background">
        <Navigation />
        <div className="hidden sm:block">
          <Sidebar />
        </div>
        <main className={`${isMobile ? 'pt-16 pb-20 px-4' : 'sm:pl-16 pt-16 pb-16 px-4'} max-w-[1920px] mx-auto transition-all duration-300`}>
          <h1 className="text-2xl font-bold mb-6 mt-4">{title}</h1>
          {children}
        </main>
        <MobileNavigation />
      </div>
    );
  }
  
  // Return null while redirecting to prevent flash of content
  return null;
};
